export enum OfferColumnField {
  ID = 'id',
  CREATED_AT = 'createdAt',
  LABEL = 'label',
  STATUS = 'status',
  ACTIONS = 'actions',
}

export const inactiveHash = '#inactive'
